import { useState, useEffect, useContext } from 'react';
import { useAuth, useQwanyx, QwantaContext } from 'qwanyx';
import { getCards } from '../getCards';

export const useAggregator = () => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Context hooks
  const { currentUser } = useAuth();
  const { selectedCard, domainId, cardRegistry } = useQwanyx();
  
  // Get current Qwanta context directly to access _id
  const stackContext = useContext(QwantaContext);
  const stackId = stackContext?._id;



  // Fetch cards when stackId changes
  const fetchCards = async () => {
    if (!stackId) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const fetchedCards = await getCards(stackId);
      setCards(fetchedCards);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching cards:', err);
    } finally {
      setLoading(false);
    }
  };

  // Auto-fetch when stackId changes
  useEffect(() => {
    fetchCards();
  }, [stackId]);

  return {
    // Data
    cards,
    loading,
    error,
    
    // Context
    currentUser,
    selectedCard,
    domainId,
    cardRegistry,
    stackContext,
    stackId,
    
    // Actions
    fetchCards,
    
    // Computed values
    cardCount: cards.length,
    hasCards: cards.length > 0,
    contextInfo: {
      userId: currentUser?.id,
      cardId: selectedCard?._id,
      editorId: selectedCard?.ed,
      domainId: selectedCard?.di || domainId,
      parentId: selectedCard?.pa,
      stackId
    }
  };
};